import React from 'react';
import { MenuItemIcon, MenuNavLink, Text } from '@ydistri/ds';
import { Tooltip } from 'antd';
import { useSider } from '../../hooks/useSider';
import { LeftMenuItem } from '@ydistri/utils';

interface MenuItemProps {
  item: LeftMenuItem;
}

/**
 * Item in menu displayed on the left either collapsed or expanded
 * @param item
 * @constructor
 */
const MenuItem: React.FC<MenuItemProps> = ({ item }: MenuItemProps) => {
  const { isLeftMenuCollapsed } = useSider();

  const tooltipTitle = isLeftMenuCollapsed ? item.label : undefined;

  return (
    <MenuNavLink
      to={item.path}
      key={item.key}
      $isCollapsed={isLeftMenuCollapsed}
      $isSelected={item.isSelected}
      $isChild={item.isChild}
      $hasChild={item.hasChild}
      $isOpened={item.isOpened}
      data-type="MenuItem"
      data-testid={item.label}
      role="menuitem"
      data-selected={item.isSelected}
    >
      <Tooltip title={tooltipTitle} placement="right">
        <MenuItemIcon $childItem={item.isChild}>{item.icon}</MenuItemIcon>
      </Tooltip>
      {!isLeftMenuCollapsed && (
        <Text $size="large" $semiBold>
          {item.label}
        </Text>
      )}
      {isLeftMenuCollapsed && item.isChild && (
        <Text $size="large" $semiBold>
          {item.shortcut}
        </Text>
      )}
    </MenuNavLink>
  );
};

export default MenuItem;
